import { Pipe, Injectable, PipeTransform } from '@angular/core';
import { Address, IAddressData } from '@df/session/api/address-book/address';
import { AddressBook } from '@df/session/api/address-book/address-book';
import { CustomerModel } from '@df/session/api/customer.model';
import { Nexus } from '@tomandco/nexus-api-types';

/**
 * converts any data to address model
 */

@Pipe({
    name: 'toAddress',
    standalone: true
})
export class ToAddressPipe implements PipeTransform {
    constructor(private toAddressPipeService: ToAddressPipeService) {}

    transform(addressData: IAddressData | Nexus.Lib.Checkout.Address | undefined | Address | number): Address | undefined {
        return this.toAddressPipeService.transform(addressData);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ToAddressPipeService {
    private cache: { [key: string]: Address } = {};

    constructor(
        private customerModel: CustomerModel,
        private addressBook: AddressBook
    ) {}

    transform(addressData: IAddressData | Nexus.Lib.Checkout.Address | undefined | Address | number): Address | undefined {
        // undefined when nothign provied
        if (!addressData) {
            return undefined;
        }
        // return source when its already an address
        if (addressData instanceof Address) {
            return addressData;
        }

        if (typeof addressData === 'number') {
            addressData = {
                customer_address_id: addressData
            };
        }

        // if customer is logged in and data contain address id then return from addres book
        if (this.customerModel.isLoggedIn && addressData.customer_address_id) {
            return this.addressBook.byId(addressData.customer_address_id);
        }

        // create new address entry otherwise, cache it
        const hash = JSON.stringify(addressData);
        if (!this.cache[hash]) {
            this.cache[hash] = new Address(addressData);
        }
        return this.cache[hash];
    }
}
